import React, { Component } from 'react';
import { connect } from "react-redux";
import { Redirect } from 'react-router-dom';
import styles from 'components/FacilityRequestComponents/AH/Modules/CustomDropDown.module.css';
import { getPlacesList } from 'action/facilitiesAction';



class AfterHoursSpacesDropDown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            spaces:null,
        };
        this.singleSpace = this.singleSpace.bind(this);
        this.multipleSpaces = this.multipleSpaces.bind(this);
        this.zoneDropDownChange = this.zoneDropDownChange.bind(this);
        this.zonedefaultDropDownChange = this.zonedefaultDropDownChange.bind(this);
    }
    
    componentWillMount() {
        this.props.getPlacesList();
    }

    componentDidMount() {
        this.setState({
            spaces: this.props.placesfromReducer,
        });
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.placesfromReducer !== nextProps.placesfromReducer) {
            this.setState({
                spaces: nextProps.placesfromReducer,
            });
           
        }
    }

    zoneDropDownChange(event){
        let {spaces}= this.state;
        let selectedZoneID = null;
        selectedZoneID = event.target.value;
        let selectedZoneData = null;
        selectedZoneData = spaces.zones.filter(x => x.zoneId === parseInt(selectedZoneID));
        this.props.onSelectedZoneDetails(selectedZoneData[0]);
    }

    zonedefaultDropDownChange(event){
        let {spaces}= this.state;
        let selectedZoneID = null;
        selectedZoneID = event.target.value;
        let selectedZoneData = null;
        selectedZoneData = spaces.zones.filter(x => x.zoneId === parseInt(selectedZoneID));
        localStorage.setItem("zoneSelectedfromList",true);
        this.props.onSelectedZoneDetails(selectedZoneData[0],1);
    }

    render() {
        let {spaces} = this.state;
        let content = "No Data";    

        if(spaces === ""){
            //redirect to Login unauthorised. status is 401
            return <Redirect to={"/FacilityManagement/Message"} />
        }
        else if(Array.isArray(spaces)){
            if(spaces.length === 0){
                return <Redirect to={"/FacilityManagement/Message"} />
            }
        }
        
        
       
        if(spaces !== undefined && spaces !== null && spaces.hasOwnProperty('zones') ) {
            if(this.props.FromComfortScreen !== undefined && this.props.FromComfortScreen !== null && this.props.FromComfortScreen === true){
                if(spaces.zones.length > 0){
                    var l_Data = spaces.zones.filter(x => x.allowTemperatureAdjustment === true);
                    spaces.zones = l_Data;
                }
            }
            if(spaces.zones.length === 1){
              
                if(this.props.defaultZoneSlection !== null && this.props.defaultZoneSlection !== undefined ){
                    //return just single space details for edit After hours data
                    let  IndexValue = null;
                    IndexValue = spaces.zones.map(function (data) { return data.zoneId; }).indexOf(this.props.defaultZoneSlection);
                    content = this.singleSpace(spaces.zones);
                    this.props.onSelectedZoneDetails(spaces.zones[IndexValue]);
                }
                else{
                      //return just single space name as text field
                    this.props.onSelectedZoneDetails(spaces.zones[0]);
                    content =  this.singleSpace(spaces.zones);
                }
               
               
            }
            else if(spaces.zones.length >= 2){
                if(this.props.defaultZoneSlection !== null && this.props.defaultZoneSlection !== undefined ){
                      //return just single space details for edit After hours data
                    let  IndexValue = null;
                    IndexValue = spaces.zones.map(function (data) { return data.zoneId; }).indexOf(this.props.defaultZoneSlection);
                    content = this.defaultSelectionSpaces(spaces.zones,this.props.defaultZoneSlection);   
                    this.props.onSelectedZoneDetails(spaces.zones[IndexValue]);
                }
                else{
                  
                      //return all the spaces in select dropdown
                      content =  this.multipleSpaces(spaces.zones);
                      this.props.onSelectedZoneDetails(spaces.zones[0]);
                }
              
            }
            else{
                  //redirect to No spaces message page.
                  return <Redirect to={"/FacilityManagement/Message"} />
            }
        }
       

        return (
            <div>{content}</div>
        );
    }

    singleSpace(data){
        let spaceHTML = null;
        spaceHTML =  <div>
                        <p className={styles.documentsformDarkLabel}>Space</p>
                        {data.map((el) => (  <p id={el.zoneId} key={el.zoneId} className={styles.documentsformlightLabel}>{el.zoneName}</p>))}
                    </div>;
        return spaceHTML;
    }

    multipleSpaces(data){
        let selectDropDownHTML = null;
       
        selectDropDownHTML=  <div><p className={styles.documentsformDarkLabel}>Spaces</p>
                                <span className={styles.customDropdown}>
                                    <select onChange={this.zoneDropDownChange}  >
                                      {data.map((el) => (<option key={el.zoneId} value={el.zoneId}>{el.zoneName}</option>))}
                                    </select>
                                </span></div>;
        return selectDropDownHTML;
    }
    defaultSelectionSpaces(data,defaultId){
        let selectDropDownHTML = null;
        selectDropDownHTML=  <div><p className={styles.documentsformDarkLabel}>Spaces</p>
                                <span className={styles.customDropdown}>
                                    <select onChange={this.zonedefaultDropDownChange} value={defaultId} >
                                      {data.map((el) => (<option key={el.zoneId} value={el.zoneId}>{el.zoneName}</option>))}
                                    </select>
                                </span></div>;
        return selectDropDownHTML;
    }

}


const mapStateToProps = state => {
    return {
        placesfromReducer: state.facilityRootReducer.places,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getPlacesList: () => dispatch(getPlacesList()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AfterHoursSpacesDropDown);